#import "./PolicyAdminFields.graphql"

fragment TrainingModuleAdminFields on TrainingModuleAdmin {
  id
  title
  slug
  controlReference
  summary
  body
  quizRequired
  unlocksAfterPrevious
  course {
    id
    title
    slug
    controlReference
    status
    requirement
    audienceCount
    category {
      id
      name
    }
    modules {
      id
    }
  }
  keyPoints
  position
  status
  audience
  audienceCount
  teams {
    id
    name
    archived
  }
  questionsPerAttempt
  passMark
  minWatchPercent
  dueWithinDays
  renewalMonths
  renewalNoticeDays
  hasVideo
  videoUrl
  videoFileName
  hasCaptions
  posterUrl
  videoDurationSeconds
  estimatedMinutes
  activeQuestionCount
  updatedAt
  links {
    id
    label
    url
    kind
  }
  policies {
    ...PolicyAdminFields
  }
  questions {
    id
    prompt
    explanation
    position
    active
    attempts
    percentCorrect
    options {
      id
      text
      correct
      position
    }
  }
}
